import { ICategory } from 'categories/types';
import {
  IPartFinderFamilyAttribute,
  IPartFinderFamilyPart,
  IPartFinderFamilyPartValue,
} from 'companySettings/types';

// A part as the wizard holds it: its values keyed by the attribute they belong to
// (getAttributeKey()), so they follow the attribute whatever its position.
export interface IFamilyPartForm extends Omit<IPartFinderFamilyPart, 'values'> {
  values: Record<string, IPartFinderFamilyPartValue[]>;
}

// `category` is the item the category field holds: the picked category, or null.
// `attributesProductTypeId` is the product type the attributes were taken from, so a change of
// product type takes them again from the new one.
export interface IUpsertPartFinderFamilyFormData {
  attributes: IPartFinderFamilyAttribute[];
  attributesProductTypeId: number | null;
  category: Pick<ICategory, 'id' | 'name'> | null;
  name: string;
  parts: IFamilyPartForm[];
  productTypeId: number | null;
}

// An attribute card's mark in the family editor: not saved yet, or saved with other content.
export enum AttributeChangeState {
  CHANGED = 'changed',
  NEW = 'new',
}
